import { TemperatureLogForm, TemperatureLogGrid, } from '@gtpl/pages/dashboard/dashboard-components/temperature-log';
import { ContainerLogBookForm, ContainerLogBookGrid } from '@gtpl/pages/logistics/logistics-components/container-log-book-form';
import { FgDamagesForm } from '@gtpl/pages/warehouse-management/warehouse-components/fg-damages-form';
import { FgDamagesGrid } from '@gtpl/pages/warehouse-management/warehouse-components/fg-damages-grid';
import { ReprocessingRepackingGrid } from '@gtpl/pages/warehouse-management/warehouse-components/reprocessing-repacking-grid';
import { ReserveRackPositions } from '@gtpl/pages/warehouse-management/warehouse-components/reserve-rack-positions';
import { StockGrid, StockLocationUpdate, } from '@gtpl/pages/warehouse-management/warehouse-components/stock-grid';
import { StockExcelUpload, StockIn, StockInForm, StockOutVerification, StockPlacementVerification, } from '@gtpl/pages/warehouse-management/warehouse-components/stock-in-form';
import { StockInReverse, StockOut, } from '@gtpl/pages/warehouse-management/warehouse-components/stock-out';
import { WarehouseDashboard } from '@gtpl/pages/warehouse-management/warehouse-components/warehouse-dashboard';
import { FgStockTransfer } from '@gtpl/pages/warehouse-management/warehouse-management-components/fg-stock-transfer';
import { FgStockTransferGrid } from '@gtpl/pages/warehouse-management/warehouse-management-components/fg-stock-transfer-grid';
import React from 'react';
import { Route } from 'react-router-dom';

export const WarehouseRoute = () => {
    return (
        <>
            <Route exact path="/stock-out-grid" component={StockOut} />
            <Route exact path="/stock-in" component={StockInForm} />
            <Route exact path="/swap-in" component={StockIn} />
            <Route exact path="/stock-placement" component={StockPlacementVerification} />
            <Route exact path="/stock-out-verification" component={StockOutVerification} />
            <Route exact path="/fg-stock" component={StockGrid} />
            <Route exact path="/wh-dashboard" component={WarehouseDashboard} />
            <Route exact path="/location-update" component={StockLocationUpdate} />
            <Route exact path="/stock-in-reverse" component={StockInReverse} />
            <Route exact path="/fg-stock-transfer-grid" component={FgStockTransferGrid} />
            <Route exact path="/fg-stock-transfer" component={FgStockTransfer} />
            <Route exact path="/reserve-racks" component={ReserveRackPositions} />
            <Route exact path="/reprocess-repacking" component={ReprocessingRepackingGrid} />
            <Route exact path="/temperature-log-view" component={TemperatureLogGrid} />
            <Route exact path="/temperature-log-form"
                render={(props) => (
                    <TemperatureLogForm temperatureData={undefined} closeForm={() => { }} />
                )} />
            <Route exact path="/container-log-book" component={ContainerLogBookForm} />
            <Route exact path="/container-log-book-grid" component={ContainerLogBookGrid} />
            <Route exact path="/fg-damages-view" component={FgDamagesGrid} />
            <Route exact path="/fg-damages-form"
                render={(props) => (
                    <FgDamagesForm fgDamgesData={undefined} isUpdate={false} closeForm={() => { }} updateItem={(undefined) => { }} />
                )} />
            <Route exact path="/fg-excel-upload" component={StockExcelUpload}/>
        </>
    );
};
